import {fetchFromApi} from './apiUtils';

const basePath = '/v1/announcements';

const getAnnouncements = () => fetchFromApi(basePath);

export default {
  getAnnouncements
};
